import { render, staticRenderFns } from "./_peBankTransfer.vue?vue&type=template&id=1ba450a0&lang=pug&"
import script from "./_peBankTransfer.vue?vue&type=script&lang=js&"
export * from "./_peBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports